const state = {
  convertUnitItems: {}
}

const mutations = {
  LOAD_CONVERT_UNIT_ITEMS (state, payload) {
    state.convertUnitItems = payload
  }
}

const actions = {
  loadExampleConvertUnitItems ({ commit }) {
    const convertUnitItems = {
      'cdc627e0-a48d-42f6-8476-778111af05be': {
        fromUnit: 'tons',
        toUnit: 'pounds',
        quantity: 2000,
        sortOrder: 1
      },
      '4461aad3-0338-4fdf-808e-5bbfdd685e2b': {
        fromUnit: 'gallons',
        toUnit: 'quarts',
        quantity: 4,
        sortOrder: 2
      },
      'f357e557-6992-4b89-8e5c-554661ea6aa9': {
        fromUnit: 'gallons',
        toUnit: 'pints',
        quantity: 8,
        sortOrder: 3
      },
      '338f800e-55aa-461d-ad96-5aba69bd2f21': {
        fromUnit: 'gallons',
        toUnit: 'ounces',
        quantity: 128,
        sortOrder: 4
      },
      'b9ca92e1-8e21-455f-a48f-51f38c647c27': {
        fromUnit: 'quarts',
        toUnit: 'ounces',
        quantity: 32,
        sortOrder: 5
      },
      '0d1afd07-806c-44ff-a3cf-228b6ff00e38': {
        fromUnit: 'pounds',
        toUnit: 'pounds',
        quantity: 1,
        sortOrder: 6
      },
      '0fc393ca-f2cd-4856-a443-630742f2ce40': {
        fromUnit: 'ounces',
        toUnit: 'ounces',
        quantity: 1,
        sortOrder: 7
      }
    }

    commit('LOAD_CONVERT_UNIT_ITEMS', convertUnitItems)
  }
}

const getters = {
  convertUnitItems: state => state.convertUnitItems,

  convertUnitItemsIdList: state => {
    return Object.keys(state.convertUnitItems)
  },

  convertUnitItemsList: (state, getters) => {
    const itemsList = getters.convertUnitItemsIdList.map((id) => {
      const item = getters.getConvertUnitItemById(id)
      return {
        id: id,
        fromUnit: item.fromUnit,
        toUnit: item.toUnit,
        quantity: item.quantity
      }
    })

    return itemsList
  },

  getConvertUnitItemById: (state) => (id) => {
    return state.convertUnitItems[id]
  },

  getConvertUnitsForAutocomplete: (state, getters) => {
    return getters.convertUnitItemsIdList.map((item) => {
      const convertUnit = getters.getConvertUnitItemById(item)
      return {
        value: item,
        text: `${convertUnit.fromUnit} -> ${convertUnit.toUnit}`
      }
    })
  }
}

const convertUnitModule = {
  state,
  mutations,
  actions,
  getters
}

export default convertUnitModule
